import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cev7opt9ab: FaireBrandEntity = {
  token: "b_cev7opt9ab",
  type: "brand",
  name: "Nature's Inventory",
  avatarUrl:
    "https://cdn.faire.com/fastly/dc5193a70d21ea9c1883a9c5b0409ddd5d04c4492c1ac71b2503f82b4bb443d0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/5a9dd36071250b5e6fa32927937acbb427d3b715278e7e9c82f4bfb3e4c17d52.png",
  logoUrl:
    "https://cdn.faire.com/fastly/dc5193a70d21ea9c1883a9c5b0409ddd5d04c4492c1ac71b2503f82b4bb443d0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5a9dd36071250b5e6fa32927937acbb427d3b715278e7e9c82f4bfb3e4c17d52.png",
  location: "Enumclaw, WA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 71,
  isInsider: true,
  description:
    "Nestled at the base of majestic Mt Rainier, we hand-craft our small batch products with superior quality ingredients. Our products are of the highest quality, but without the cost. We hand bottle and label them ourselves, so when you buy from us you are helping employ real people, not machines. \n\nWe know how hard, and expensive it can be to both take good care of yourself and be environmentally responsible, all without breaking the bank. Our customers want socially conscious, ethically sourced and cruelty free products at a great price point. So we set forth to deliver!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:31.610Z",
    importedBy: "entity-db-cli",
  },
};
